import React, { MouseEvent } from 'react'
import { Dropzone, IFileObject } from 'transfix-ui/components/Dropzone'
import { Box, Typography } from 'transfix-ui/core'
import { IFile, IFileCreate, TFileType } from 'apps/fleet-planner/types/loads'
import { mapDropzoneFiles } from 'apps/fleet-planner/utils/fileUtils'
import { AttachmentList } from '../AttachmentList'
import { SectionHeaderText } from '../create-load/SectionHeaderText'

interface IAttachmentsProps<T extends TFileType> {
  files?: IFile[]
  headerText: string
  subHeaderText?: string
  onFileChange: (filesArray: IFileCreate[], fileType: T) => Promise<void>
  onFileDelete: (event: MouseEvent<HTMLButtonElement>) => Promise<void>
  fileType: T
  /**
   * Transfix imported loads are external
   */
  isExternal?: boolean
  dropzoneMessage: string
  /**
   * @default true
   */
  showIcon?: boolean
  isLoading?: boolean
}

export function Attachments<T extends TFileType>({
  headerText,
  subHeaderText,
  files = [],
  onFileChange,
  onFileDelete,
  isExternal,
  isLoading,
  dropzoneMessage,
  fileType,
  showIcon = true,
}: IAttachmentsProps<T>) {
  const fileChangeHandler = (filesArray: IFileObject[] = []) => {
    if (filesArray) {
      const pkgFiles = mapDropzoneFiles(filesArray)
      if (files) onFileChange([...files, ...pkgFiles], fileType)
    }
  }

  const fileDeleteHandler = (event: MouseEvent<HTMLButtonElement>) => {
    onFileDelete(event)
  }

  return (
    <Box>
      <Box mb={1.5}>
        <SectionHeaderText>{headerText}</SectionHeaderText>
        {subHeaderText && (
          <Typography variant='body2' component='div'>
            {subHeaderText}
          </Typography>
        )}
        {isExternal && (
          <span className='text-secondary text-caption-semibold pr1'>
            These files are not shared with Transfix.
          </span>
        )}
      </Box>
      {files.length > 0 && (
        <Box mb={1.5}>
          <AttachmentList
            isLoading={isLoading}
            showIcon={showIcon}
            attachments={files}
            onFileDelete={fileDeleteHandler}
          />
        </Box>
      )}
      <Box>
        <Dropzone dropZoneText={dropzoneMessage} onFileChange={fileChangeHandler} />
      </Box>
    </Box>
  )
}
